import { Text } from '@/components'
import InnerCard from '@/components/InnerCard/InnerCard'
import Separator from '@/app/components/Separator/Separator'
import classes from '@/utils/classes/classes'

type Props = {
  title: string
  subtitle?: string
  illustration?: React.ReactNode
  children?: React.ReactNode
  className?: string
}

export default function ConfigureDeviceCard({
  title,
  subtitle,
  illustration,
  children,
  className,
}: Props) {
  return (
    <InnerCard>
      <div
        className={classes(
          'flex flex-row items-center gap-3 mb-8 mt-2',
          className,
        )}
      >
        <div className="flex-1 min-w-0">
          <Text
            variant="subheader"
            className="font-bold text-themed-grey-900 truncate"
          >
            {title}
          </Text>
          {subtitle && (
            <Text variant="body4" className="text-themed-grey-500 truncate">
              {subtitle}
            </Text>
          )}
        </div>
        {illustration && (
          <div className="flex-none flex items-center justify-end mr-4">
            {illustration}
          </div>
        )}
      </div>
      {children && (
        <>
          <Separator className="my-4 bg-themed-grey-200" />
          <div className="flex flex-col gap-4">{children}</div>
        </>
      )}
    </InnerCard>
  )
}

ConfigureDeviceCard.Divider = function ConfigureDeviceCardDivider() {
  return <Separator className="bg-themed-grey-200 my-4" />
}
